import React from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-bs5"; // Bootstrap 5 styling
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; // Bootstrap 5 CSS
import $ from "jquery";

// Optional: Add responsive plugin
import "datatables.net-responsive-bs5";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css";

// Optional: Add select plugin
import "datatables.net-select-bs5";
import "datatables.net-select-bs5/css/select.bootstrap5.min.css";

DataTable.use(DT);

const ReactDataTable = ({
  data = [],
  className = "table table-striped table-bordered align-middle",
  onHandleShowEndModal,
}) => {
  // Format date for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // Format numbers with thousand separators
  const formatNumber = (num) => {
    return num.toLocaleString("en-US");
  };

  // Get status badge class
  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "Active":
        return "badge bg-success";
      case "Ended":
        return "badge bg-secondary";
      default:
        return "badge bg-light text-dark";
    }
  };

  // Add this function after the helper functions (after getStatusBadgeClass)
  const formatChildRow = (data) => {
    return `
      <div class="p-3 bg-light border-start border-success border-4">
        <div class="row">
          <!-- Event Details -->
          <div class="col-md-6 mb-3">
            <h6 class="text-success fw-bold mb-2">
              <i class="fa fa-info-circle me-2"></i>Event Creation Details
            </h6>
            <table class="table table-sm table-borderless mb-0">
              <tr>
                <td class="text-muted" style="width: 140px;">Created At:</td>
                <td class="fw-semibold">${formatDate(data.createdAt)}</td>
              </tr>
              <tr>
                <td class="text-muted">Official Name:</td>
                <td class="fw-semibold">${data.officialFirstName} ${
      data.officialLastName
    }</td>
              </tr>
              <tr>
                <td class="text-muted align-top">Comments:</td>
                <td><em class="text-secondary">${
                  data.comments || "No comments provided"
                }</em></td>
              </tr>
            </table>
          </div>
          
          <!-- Event Statistics -->
          <div class="col-md-6 mb-3">
            <h6 class="text-primary fw-bold mb-2">
              <i class="fa fa-chart-bar me-2"></i>Event Statistics
            </h6>
            <table class="table table-sm table-borderless mb-0">
              <tr>
                <td class="text-muted" style="width: 140px;">Event Type:</td>
                <td class="fw-semibold">${data.eventType}</td>
              </tr>
              <tr>
                <td class="text-muted">Start Date:</td>
                <td>${formatDate(data.startDate)}</td>
              </tr>
              ${
                data.endDate
                  ? `
              <tr>
                <td class="text-muted">End Date:</td>
                <td>${formatDate(data.endDate)}</td>
              </tr>
              `
                  : ""
              }
            </table>
          </div>
        </div>
      </div>
    `;
  };

  const tableColumns = [
    {
      title: "",
      data: null,
      className: "dt-control text-center",
      orderable: false,
      width: "3%",
      defaultContent: "",
      render: () => "", // Icon handled by CSS
    },
    {
      title: "ID",
      data: "id",
      className: "text-center",
      width: "4%",
      render: (data) => `<div class="fw-bold">${data}</div>`,
    },
    {
      title: "Official Start Date",
      data: "startDate",
      className: "text-center",
      width: "10%",
      render: (data) => `<small>${formatDate(data)}</small>`,
    },
    {
      title: "Event Name",
      data: "eventName",
      render: (data, type, row) => `
        <a href="/evacuation-portal-panels/evacuation-orders?eventId=${row.id}" 
           class="text-decoration-none fw-bold text-primary">
          ${data}
        </a>
      `,
    },
    {
      title: "Created By",
      data: "createdBy",
      render: (data) => `<small>${data}</small>`,
    },
    {
      title: "Zones",
      data: "numberOfZones",
      className: "text-end",
      render: (data) => `<strong>${formatNumber(data)}</strong>`,
    },
    {
      title: "Total People",
      data: "numberOfPeople",
      className: "text-end",
      render: (data) => `<strong>${formatNumber(data)}</strong>`,
    },
    {
      title: "Total Vehicles",
      data: "numberOfVehicles",
      className: "text-end",
      render: (data) => `<strong>${formatNumber(data)}</strong>`,
    },
    {
      title: "Total Dwellings",
      data: "numberOfDwellingsUnder",
      className: "text-end",
      render: (data) => `<strong>${formatNumber(data)}</strong>`,
    },
    {
      title: "Total Addresses",
      data: "numberOfAddressesUnder",
      className: "text-end",
      render: (data) => `<strong>${formatNumber(data)}</strong>`,
    },
    {
      title: "Evacuation %",
      data: "evacuationPercentage",
      className: "text-end",
      render: (data) => {
        const percentage = parseFloat(data) || 0;
        const color =
          percentage >= 90
            ? "success"
            : percentage >= 70
            ? "warning"
            : "danger";
        return `
          <div class="progress" style="height: 20px; min-width: 80px;">
            <div
              class="progress-bar bg-${color}"
              role="progressbar"
              style="width: ${percentage}%"
              aria-valuenow="${percentage}"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              ${percentage}%
            </div>
          </div>
        `;
      },
    },
    {
      title: "Status",
      data: "status",
      className: "text-center",
      render: (data) =>
        `<span class="${getStatusBadgeClass(data)}">${data}</span>`,
    },
    {
      title: "Check Orders",
      data: null,
      className: "text-center",
      orderable: false,
      render: (data, type, row) => `
        <a href="/evacuation-portal-panels/evacuation-orders?eventId=${row.id}" 
           class="btn btn-sm btn-outline-primary" 
           title="View Evacuation Orders">
          <i class="fa fa-list"></i>
        </a>
      `,
    },
    {
      title: "End Event",
      data: null,
      className: "text-center",
      orderable: false,
      render: (data, type, row) => {
        const isActive = row.status === "Active";
        const btnClass = isActive
          ? "btn-outline-danger"
          : "btn-outline-secondary";
        const disabled = !isActive ? "disabled" : "";
        return `
          <button
            type="button"
            class="btn btn-sm ${btnClass} end-event-btn"
            data-event-id="${row.id}"
            data-event-name="${row.eventName}"
            data-event-percentage="${row.evacuationPercentage}"
            data-event-zones="${row.numberOfZones}"
            title="End Evacuation Event"
            ${disabled}
          >
            <i class="fa fa-flag-checkered"></i>
          </button>
        `;
      },
    },
  ];

  const tableOptions = {
    paging: false,
    searching: false,
    ordering: true,
    info: true,
    order: [[1, "desc"]], // Sort by ID descending
    language: {
      lengthMenu: "Show _MENU_ events",
      info: "Showing _START_ to _END_ of _TOTAL_ events",
      infoEmpty: "No events available",
      emptyTable: "No evacuation events found",
      infoFiltered: "(filtered from _MAX_ total events)",
      zeroRecords: "No matching events found",
    },
    dom:
      '<"row"<"col-sm-12 col-md-6"l><"col-sm-12 col-md-6"f>>' +
      '<"row"<"col-sm-12"tr>>' +
      '<"row"<"col-sm-12 col-md-5"i><"col-sm-12 col-md-7"p>>',
    columns: tableColumns,
    createdRow: (row, rowData, dataIndex) => {
      // Expand/collapse handler
      $(row)
        .find("td.dt-control")
        .on("click", function () {
          const tr = $(this).closest("tr");
          const table = $(tr).closest("table").DataTable();
          const tableRow = table.row(tr);

          if (tableRow.child.isShown()) {
            tableRow.child.hide();
            tr.removeClass("shown");
          } else {
            tableRow.child(formatChildRow(rowData)).show();
            tr.addClass("shown");
          }
        });

      // End event button handler
      $(row)
        .find(".end-event-btn:not([disabled])")
        .on("click", function (e) {
          e.preventDefault();
          const eventId = parseInt($(this).data("event-id"));
          const event = data.find((e) => e.id === eventId);
          if (event) {
            onHandleShowEndModal(event);
          }
        });
    },
  };

  const defaultOptions = {
    responsive: false,
    autoWidth: false,
    dom:
      '<"row"<"col-sm-12 col-md-6"l><"col-sm-12 col-md-6"f>>' +
      '<"row"<"col-sm-12"tr>>' +
      '<"row"<"col-sm-12 col-md-5"i><"col-sm-12 col-md-7"p>>',
    ...tableOptions,
  };

  return (
    <DataTable
      data={data}
      options={tableOptions}
      className={className}
    >
      <thead>
        <tr>
          {tableColumns.map((col, idx) => (
            <th key={idx}>{col.title || ""}</th>
          ))}
        </tr>
      </thead>
    </DataTable>
  );
};

export default ReactDataTable;
